import React, { lazy, Suspense } from 'react';
import classNames from 'classnames';
import { translate } from 'react-polyglot';
import { connect } from 'react-redux';
import Joyride from 'react-joyride';
import { helpGuideSteps } from './constants/helpGuideSteps';
import DocumentTitle from 'react-document-title';
import { links } from '../../lib/constants';
import { isRightToLeftDirection } from '../../util/utils';
import './Home.scss';
import LoaderBlock from '../LoaderBlock';
import { favouriteBookWorkflow } from '../../redux/bookActions';
import SectionBanner from '../SectionBanner/SectionBanner';
import { SECTION_BANNER_TYPES } from '../../constants/constants';

const BookSuggestions = lazy(() => import('./components/BookSuggestions'));
const BookSelections = lazy(() => import('./components/BookSelections'));
const Video = lazy(() => import('./components/Video'));
const DonateContainer = lazy(() =>
    import('../DonateContainer/DonateContainer')
);
const BannerComponent = lazy(() => import('../../helpers/BannerComponentHook'));

const HomeV2 = ({
    t,
    isLoggedIn,
    helpStatus,
    newlyAddedBooks,
    viewport,
    hasUserHistory,
    recommendedBooks,
    trendingBooks,
    readingLists,
    videoReadCountWorkflow,
    videos,
    favouriteBookWorkflow,
}) => {
    const baseClassName = 'pb-home';
    const myLanguage = localStorage.getItem('locale');

    const classes = {
        [baseClassName]: true,
    };
    return (
        <div className={classNames(classes)}>
            <Joyride
                enabled={true}
                steps={
                    isLoggedIn
                        ? helpGuideSteps(t).loggedInSteps
                        : helpGuideSteps(t).loggedOutSteps
                }
                continuous
                showProgress
                run={helpStatus}
                scrollToFirstStep
                scrollOffset={40}
                disableScrolling={false}
                locale={{
                    next: t('global.Next'),
                    back: t('global.Back'),
                    last: t('global.Last'),
                }}
                styles={{
                    options: {
                        arrowColor: '#e3ffeb',
                        backgroundColor: '#e3ffeb',
                        textColor: '#004a14',
                        overlayColor: 'rgba(0, 0, 0, 0.8)',
                        primaryColor: '#007AA4',
                        spotlightShadow: '0 0 15px rgba(0, 0, 0, 0.8)',
                        zIndex: 1000,
                    },
                }}
            />
            <DocumentTitle title={`${t('global.site-title')}`} />
            {(myLanguage === 'en' || myLanguage === 'hi') && (
                <DonateContainer />
            )}
            <Suspense fallback={<LoaderBlock />}>
                <BannerComponent bannerType={'Home'} />
                <SectionBanner bannerType={SECTION_BANNER_TYPES.intro} />
                <div className={`${baseClassName}__container`}>
                    <BookSuggestions
                        t={t}
                        isLoggedIn={isLoggedIn}
                        baseClassName={baseClassName}
                        books={newlyAddedBooks}
                        viewport={viewport}
                        favouriteBookWorkflow={favouriteBookWorkflow}
                        isRightToLeftDirection={isRightToLeftDirection}
                        title={
                            hasUserHistory
                                ? t('Home.book-suggestions-title')
                                : t('Home.newlyAddedBooks')
                        }
                        subTitle={t('Home.moreNewlyAddedBooks')}
                        action={links.allBooks()}
                    />
                    <BookSuggestions
                        t={t}
                        isLoggedIn={isLoggedIn}
                        baseClassName={baseClassName}
                        books={trendingBooks}
                        viewport={viewport}
                        isRightToLeftDirection={isRightToLeftDirection}
                        favouriteBookWorkflow={favouriteBookWorkflow}
                        title={
                            hasUserHistory
                                ? t('Home.book-suggestions-title')
                                : t('Home.trendingBooks')
                        }
                        subTitle={t('Home.moreTrendingBooks')}
                        action={links.allTrendingBooks()}
                    />
                    <SectionBanner bannerType={SECTION_BANNER_TYPES.signUp} />

                    <BookSelections
                        t={t}
                        baseClassName={baseClassName}
                        readingLists={readingLists}
                        viewport={viewport}
                        hasUserHistory={hasUserHistory}
                        isRightToLeftDirection={isRightToLeftDirection}
                    />
                    <Video
                        t={t}
                        videos={videos}
                        hasUserHistory={hasUserHistory}
                        viewport={viewport}
                        videoReadCountWorkflow={videoReadCountWorkflow}
                        isRightToLeftDirection={isRightToLeftDirection}
                        isLoggedIn={isLoggedIn}
                        baseClassName={baseClassName}
                    />
                </div>
                <SectionBanner bannerType={SECTION_BANNER_TYPES.affiliation} />
            </Suspense>
        </div>
    );
};

const mapStateToProps = ({ help }) => {
    return {
        helpStatus: help.helpStatus,
    };
};

const mapDispatchToProps = {
    favouriteBookWorkflow,
};

export default translate()(
    connect(mapStateToProps, mapDispatchToProps)(HomeV2)
);
